import React from 'react'

const Info = () => {
  return (
    <div className="about_info grid">
        <div className="about_box">
            <i className="bx bx-award about_icon"></i>
            <h3 className="about_title">Experience</h3>
            <span className="about_subtitle">5+ Years</span>
        </div>

        <div className="about_box">
            <i className="bx bx-shield-quarter about_icon"></i>
            <h3 className="about_title">Focus</h3>
            <span className="about_subtitle">Reliability &amp; Security</span>
        </div>

        <div className="about_box">
            <i className="bx bx-group about_icon"></i>
            <h3 className="about_title">Role</h3>
            <span className="about_subtitle">Platform Lead</span>
        </div>
    </div>
  )
}

export default Info
